import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { ExternalLink } from 'lucide-react';

/**
 * Credits Page
 * Attributions for third-party assets used in the application
 */
export default function CreditsPage() {
  const credits = [
    {
      category: "Images & Icons",
      items: [
        {
          name: "Beta Tester Badge",
          source: "Vecteezy.com",
          url: "https://www.vecteezy.com",
          description: "Cartoon emoji character used as beta tester badge"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Credits & Attributions</h1>
        <p className="text-gray-600 mb-8">
          We gratefully acknowledge the following resources used in this application.
        </p>

        {credits.map((section, idx) => (
          <Card key={idx} className="mb-6">
            <CardHeader>
              <CardTitle className="text-lg">{section.category}</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-4">
                {section.items.map((item, itemIdx) => (
                  <li key={itemIdx} className="flex items-start gap-3">
                    <div className="flex-1">
                      <p className="font-medium">{item.name}</p>
                      <p className="text-sm text-gray-600">{item.description}</p>
                      <a 
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-blue-600 hover:underline inline-flex items-center gap-1 mt-1"
                      >
                        {item.source}
                        <ExternalLink className="w-3 h-3" />
                      </a>
                    </div>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}

        <p className="text-sm text-gray-500 mt-8">
          If you believe any attribution is missing or incorrect, please contact us.
        </p>
      </div>
    </div>
  );
}
